export default __webpack_public_path__ + "static/media/TEXTURA_03.8b598baf.png";